var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.005 7.16658H14.1717V5.49992C14.1717 3.19992 12.305 1.33325 10.005 1.33325C7.70505 1.33325 5.83838 3.19992 5.83838 5.49992V7.16658H5.00505C4.08838 7.16658 3.33838 7.91658 3.33838 8.83325V17.1666C3.33838 18.0833 4.08838 18.8333 5.00505 18.8333H15.005C15.9217 18.8333 16.6717 18.0833 16.6717 17.1666V8.83325C16.6717 7.91658 15.9217 7.16658 15.005 7.16658ZM7.50505 5.49992C7.50505 4.11659 8.62171 2.99992 10.005 2.99992C11.3884 2.99992 12.505 4.11659 12.505 5.49992V7.16658H7.50505V5.49992ZM15.005 17.1666H5.00505V8.83325H15.005V17.1666ZM10.005 14.6666C10.9217 14.6666 11.6717 13.9166 11.6717 12.9999C11.6717 12.0833 10.9217 11.3333 10.005 11.3333C9.08838 11.3333 8.33838 12.0833 8.33838 12.9999C8.33838 13.9166 9.08838 14.6666 10.005 14.6666Z",
    fill: "#7B7979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.70d6270e.svg";
export { ForwardRef as ReactComponent };